import { useEffect, useState } from "react";
import api, { apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Checkbox } from "@/components/ui/checkbox";
import { niceName } from "@/lib/format";

export function ImpicResponsaveis({ canEdit }) {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/impic/officers").then(({ data }) => setRows(data)).catch(() => setRows([])); }, []);
  const toggle = async (id) => {
    const next = rows.map((r) => (r.id === id ? { ...r, officer: !r.officer } : r));
    try {
      await api.put("/impic/officers", { ids: next.filter((r) => r.officer).map((r) => r.id) });
      setRows(next);
      toast.success("Responsáveis atualizados");
    } catch (e) { toast.error(apiErr(e.response?.data?.detail)); }
  };
  if (!rows) return null;
  return (
    <div data-testid="impic-officers">
      <h2 className="font-semibold text-[15px] navy-text">Responsável pelo cumprimento</h2>
      <p className="text-[13px] text-slate-500 mt-0.5">A Direção tem sempre acesso. Pode nomear também pessoas da Gestão processual.</p>
      {rows.length === 0 ? <p className="text-[13px] text-slate-400 mt-3">Não há ninguém na Gestão processual.</p> : (
        <ul className="mt-3 space-y-2">
          {rows.map((r) => (
            <li key={r.id} className="flex items-center gap-2.5 text-sm">
              <Checkbox id={`off-${r.id}`} checked={r.officer} disabled={!canEdit} onCheckedChange={() => toggle(r.id)} data-testid={`impic-officer-${r.id}`} />
              <label htmlFor={`off-${r.id}`} className={canEdit ? "cursor-pointer" : ""}>{niceName(r.name)}</label>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
